// @mui material components
import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Tooltip,
  Button,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import AppConfig from "appConfig";
import DataTable from "theme/Tables/DataTable";
import usePageTitle from "app/pageTitle";

function CampaignLocationAttendancesPage() {
  const pageTitle = "Campaign Location Attendance";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  // const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [campaignLocation, setCampaignLocation] = useState({});
  const [agentAttendances, setAgentAttendances] = useState([]);
  // const [attendanceMetrics, setAttendanceMetrics] = useState(null);

  const agentAttendancesTableColumns = [
    { Header: "Photo", accessor: "photo", align: "left" },
    { Header: "Agent", accessor: "agent", align: "left" },
    { Header: "Time", accessor: "time", align: "left" },
    { Header: "Attendance", accessor: "late", align: "center" },
    { Header: "View Map", accessor: "location", align: "right" },
  ];

  const buildAttendancesRows = (data) => {
    const rows = [];
    data.map((attendance) => {
      rows.push({
        photo: (
          <MDBox>
            {attendance.photo ? (
              <img src={attendance.photo} alt="" width={96} />
            ) : (
              <MDTypography variant="h6" fontWeight="light" fontSize={14}>
                ---
              </MDTypography>
            )}
          </MDBox>
        ),
        agent: attendance.agent,
        time: attendance.created,
        late: !attendance.is_late ? "EARLY" : "LATE",
        location: (
          <Tooltip title="View On Map">
            <MDButton
              size="small"
              variant="outlined"
              color="warning"
              iconOnly
              onClick={() => {
                const maplink = `https://maps.google.com?q=${attendance.latitude},${attendance.longitude}`;
                window.open(maplink, "_blank");
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                location_on
              </Icon>
            </MDButton>
          </Tooltip>
        ),
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/campaigns/locations/${ref}/attendances.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaignLocation(result.data.data.campaign_location);
            // setCampaignLocation(result.data.data.campaign_location);
            const attendances = buildAttendancesRows(result.data.data.attendances);
            setAgentAttendances(attendances);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={3} mb={3}>
        <MDBox mb={2} display="flex" justifyContent="space-between">
          <MDBox ml={-2}>
            <Button
              color="dark"
              startIcon={<Icon>chevron_left</Icon>}
              onClick={() => {
                window.history.back();
              }}
            >
              Back
            </Button>
          </MDBox>
          <MDBox>
            <Button
              color="dark"
              startIcon={<Icon>sync</Icon>}
              onClick={() => {
                setRefreshPage(!refreshPage);
              }}
            >
              Refresh
            </Button>
          </MDBox>
        </MDBox>
        <MDBox>
          <Card>
            <MDBox p={2}>
              <MDBox mb={1}>
                <MDTypography variant="h6" fontSize={14} fontWeight="light">
                  Attendances
                </MDTypography>
                <MDTypography variant="h6">{campaignLocation.title}</MDTypography>
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
        <MDBox mt={5}>
          <Card>
            <MDBox p={2}>
              <MDBox>
                {agentAttendances.length > 0 ? (
                  <MDBox mb={3}>
                    <DataTable
                      table={{ columns: agentAttendancesTableColumns, rows: agentAttendances }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                ) : (
                  <MDBox>
                    <MDTypography variant="caption" fontSize={14}>
                      No agents have checked in yet.
                    </MDTypography>
                  </MDBox>
                )}
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CampaignLocationAttendancesPage;
